<p>
  <mat-form-field appearance="legacy">
    <input class="user-input" matInput placeholder="Enter Username" [(ngModel)]="user_name.username" cdkFocusInitial
           (keydown.enter)="close()"
           [matAutocomplete]="auto"
           [readOnly]="optionSelected">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="show_fn" (optionSelected)="option($event)">
      <mat-option *ngFor="let username of users_list" [value]="username">{{username.username}}</mat-option>
    </mat-autocomplete>
    <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
    <mat-hint>This is used for debugging</mat-hint>
  </mat-form-field>
  <mat-dialog-actions align="end">
    <button class="btn-accept-user" mat-button color="primary" (click)="close()" >OK</button>
  </mat-dialog-actions>
</p>
